import script from "./FatigueAssessmentCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./FatigueAssessmentCompleted.vue?vue&type=script&setup=true&lang=js"

import "./FatigueAssessmentCompleted.vue?vue&type=style&index=0&id=740c9772&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-740c9772"]])

export default __exports__